// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-b-2-wcharts-tsx": () => import("./../../../src/pages/b2wcharts.tsx" /* webpackChunkName: "component---src-pages-b-2-wcharts-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-keywords-tsx": () => import("./../../../src/pages/keywords.tsx" /* webpackChunkName: "component---src-pages-keywords-tsx" */)
}

